import {fetch, fetchX} from '../config/axios'
import {isHidden} from "vant/lib/utils/dom/style";

// 砍一刀系统配置信息接口
export function ForKYDConfig(params) {
  return fetch(params, '/ForKYDConfig', true)
}

// 奖品列表-领取(砍一刀)
export function ForKYDPrizeListToGet(params) {
  return fetch(params, '/ForKYDPrizeListToGet', true)
}

// 奖品列表-今天
export function ForKYDPrizeListToday(params) {
  return fetch(params, '/ForKYDPrizeListToday', true)
}

// 奖品列表-全部
export function ForKYDPrizeList(params) {
  return fetch(params, '/ForKYDPrizeList', true)
}

// 消息列表
export function messageaList(params) {
  return fetch(params, '/messageaList', true)
}

// 消息删除
export function delMessage(params) {
  return fetch(params, '/delMessage', true)
}

// 消息详情
export function msgDetail(params) {
  return fetch(params, '/msgDetail', true)
}

// 设置联系信息接口
export function ForSetContact(params) {
  return fetch(params, '/ForSetContact', true)
}

// 个人中心设置添加openid绑定，正式接口
export function ForTxopenid(params) {
  return fetch(params, '/ForTxopenid', true)
}

// 分享
export function sharePicture(params) {
  return fetch(params, '/sharePicture', true)
}

// 微信扫码获取openid
export function ForWxScanningCode(params) {
  return fetch(params, '/ForWxScanningCode')
}

// 支付宝扫码,用于获取aliid
export function ForALiScanningCode(params) {
  return fetch(params, '/ForALiScanningCode')
}

// 扫码后 ，绑定会员接口
export function BindMemberOpenid(params) {
  return fetch(params, '/BindMemberOpenid')
}

// 附近商圈 下订单
export function ShopGenerateorder(params) {
  return fetch(params, '/ShopGenerateorder')
}

// 新的绑定上下级,个人中心邀请
export function newbindRelation(params) {
  return fetch(params, '/newbindRelation', true)
}

// 绑定上下级,详情页面
export function bindRelation(params) {
  return fetch(params, '/bindRelation', true)
}

// 会员提现银行卡-列表接口
export function ForUserBankList(params) {
  return fetch(params, '/ForUserBankList', true)
}

// 会员提现 接口
export function ForWithdrawalsAdd(params) {
  return fetch(params, '/ForWithdrawalsAdd', true)
}

// 会员提现银行卡-添加
export function ForUserBankAdd(params) {
  return fetch(params, '/ForUserBankAdd', true)
}

//会员提现银行卡-删除
export function ForUserBankDelete(params) {
  return fetch(params, '/ForUserBankDelete', true)
}

//注册会员列表接口
export function ForRegCardList(params) {
  return fetch(params, '/ForRegCardList', true)
}

//会员收入列表接口
export function ForCardIncomeList(params) {
  return fetch(params, '/ForCardIncomeList', true)
}

// 推荐店铺列表
export function recommendShopList(params) {
  return fetch(params, '/recommendShopList', true)
}

// 申请全国厂家总店
export function applyNationalShop(params) {
  return fetch(params, '/applyNationalShop', true)
}

// 申请全国厂家总店店铺选择
export function findStoreList(params) {
  return fetch(params, '/findStoreList', true)
}

// 附近商家生成二维码
export function createQrCode(params) {
  return fetch(params, '/createQrCode', true)
}

// 申请全国厂家总店商品选择
export function findProductListStoreId(params) {
  return fetch(params, '/findProductListStoreId', true)
}

// 会员流量补贴申请接口
export function ForLLBTApply(params) {
  return fetch(params, '/ForLLBTApply', true)
}

// 选获权申请接口
export function ForXHQApply(params) {
  return fetch(params, '/ForXHQApply', true)
}

// 选获权，判断是否第一次下单
export function IsfirstXHQApply(params) {
  return fetch(params, '/IsfirstXHQApply', true)
}

// 选获权转让接口
export function ForXHQTurn(params) {
  return fetch(params, '/ForXHQTurn', true)
}

// 选获权转让列表
export function ForXHQTurnList(params) {
  return fetch(params, '/ForXHQTurnList', true)
}

// 赠品列表接口
export function ForGiftList(params) {
  return fetch(params, '/ForGiftList', true)
}

// 旅游列表接口
export function TravelList(params) {
  return fetch(params, '/TravelList', true)
}

// 云店铺销售列表接口
export function ForGetCSSaleLog(params) {
  return fetch(params, '/ForGetCSSaleLog', true)
}

// 赠品签收接口
export function ForGiftSureSign(params) {
  return fetch(params, '/ForGiftSureSign', true)
}

// 赠品领取接口
export function ForGiftGoGet(params) {
  return fetch(params, '/ForGiftGoGet', true)
}

// 赠品支付申请接口
export function ForGiftApply(params) {
  return fetch(params, '/ForGiftApply', true)
}

// 奖品列表接口
export function ForPrizeList(params) {
  return fetch(params, '/ForPrizeList', true)
}

// 奖品领取（发货）
export function ForPrizeToGetSend(params) {
  return fetch(params, '/ForPrizeToGetSend', true)
}

// 奖品领取（回购）
export function ForPrizeToGetBack(params) {
  return fetch(params, '/ForPrizeToGetBack', true)
}

// // 奖品领取-转免费接口
// export function ForPrizeToFree (params) {
//   return fetch(params, '/ForPrizeToFree', true)
// }
// 奖品支付申请
export function ForPrizeApply(params) {
  return fetch(params, '/ForPrizeApply', true)
}

// 奖品签收接口
export function ForPrizeSureSign(params) {
  return fetch(params, '/ForPrizeSureSign', true)
}

// 查询店铺简介（实体店铺中用）
export function findShopDesc(params) {
  return fetch(params, '/findShopDesc')
}

// 提交店铺简介（已完成）
export function submitShopDesc(params) {
  return fetch(params, '/submitShopDesc', true)
}

// 根据商户ID查询下过的订单(实体店铺交易记录)
export function ForGetShoporder(params) {
  return fetch(params, '/ForGetShoporder', true)
}

// 新实体店铺信息（线下订单统计）
export function shopInfoOrder(params) {
  return fetch(params, '/shopInfoOrder', true)
}

// 根据guid查询自己购买过的商品
export function ForGetzjgooods(params) {
  return fetch(params, '/ForGetzjgooods', true)
}

// 云店铺产品-是否已有产品代理
export function msmCheck(params) {
  return fetch(params, '/msmCheck', true)
}

// 个人中心信息
export function personalCenterInfo(params) {
  return fetch(params, '/personalCenterInfo', true)
}

// 个人中心信息，不跳转到登陆页面
export function personalCenterInfoGui(params) {
  return fetch(params, '/personalCenterInfo')
}

// 爆品奖励-领取接口
export function ForBPPrizeToGet(params) {
  return fetch(params, '/ForBPPrizeToGet')
}

// 上传图片
export function uploadFile(params) {
  return fetch(params, '/uploadFile', true)
}

// 实体商家入驻行业下拉
export function industryList(params) {
  return fetch(params, '/industryList', true)
}

// 实体商家入驻
export function shopEnter(params) {
  return fetch(params, '/shopEnter', true)
}

// 厂家入驻
export function factoryEnter(params) {
  return fetch(params, '/factoryEnter', true)
}

// 收藏的店
export function collectionShopList(params) {
  return fetch(params, '/collectionShopList', true)
}

// 我的店铺
export function findProxyProductListById(params) {
  return fetch(params, '/findProxyProductListById', true)
}

// 帮助中心
export function questionList(params) {
  return fetch(params, '/questionList')
}

// 修改个人信息
export function updateInfo(params) {
  return fetch(params, '/updateInfo', true)
}

// 修改密码
export function editPassword(params) {
  return fetch(params, '/editPassword', true)
}

// 收货地址列表
export function addressList(params) {
  return fetch(params, '/addressList', true)
}

// 添加编辑地址
export function addOrUpdateAddr(params) {
  return fetch(params, '/addOrUpdateAddr', true)
}

// 设置默认地址
export function setDefaultAddr(params) {
  return fetch(params, '/setDefaultAddr', true)
}

// 删除地址
export function delAddress(params) {
  return fetch(params, '/delAddress', true)
}

// 地址详情
export function addressDetail(params, isHidden) {
  return fetch(params, '/addressDetail', true, isHidden)
}

// 默认收货地址
export function confirmOrderInfo(params, isHidden) {
  return fetch(params, '/confirmOrderInfo', true, isHidden)
}

// 退出登录
export function logout(params) {
  return fetch(params, '/logout', true)
}

// 购物车
export function cartList(params, isHidden) {
  return fetch(params, '/cartList', true, isHidden)
}

// 删除购物车
export function delCart(params) {
  return fetch(params, '/delCart', true)
}

// 修改购物车
export function editCart(params) {
  return fetch(params, '/editCart', true)
}

// 云店铺产品-添加
export function ForCFMGoodsAdd(params) {
  return fetch(params, '/ForCFMGoodsAdd', true)
}

// 云店铺产品-列表
export function ForCFMGoodsList(params) {
  return fetch(params, '/ForCFMGoodsList', false)
}

// 云店铺产品-删除
export function ForCFMGoodsDelete(params) {
  return fetch(params, '/ForCFMGoodsDelete', true)
}

// 云店铺产品-置顶
export function ForCFMGoodsSetTop(params) {
  return fetch(params, '/ForCFMGoodsSetTop', true)
}// 云店铺产品-排序
export function ForCFMGoodsSetSort(params) {
  return fetch(params, '/ForCFMGoodsSetSort', true)
}

// 云店铺产品-设置销售标签
export function ForCFMGoodsSetTag(params) {
  return fetch(params, '/ForCFMGoodsSetTag', true)
}

// 申请单品代理
export function applyPCAApply(params) {
  return fetch(params, '/applyPCAApply', true)
}

// 城市合伙人-开通（空开）
// export function ForCFDMEmptyOpen (params) {
//   return fetch(params, '/ForCFDMEmptyOpen', true)
// }
// // 城市合伙人-可申请类型列表
// export function ForNFHCFDMList (params) {
//   return fetch(params, '/ForNFHCFDMList', true)
// }
// 消费券购买申请接口
export function ForXFQApply(params) {
  return fetch(params, '/ForXFQApply', true)
}

// 购买产品优惠券(开通VIP)
export function ForVIPApply(params) {
  return fetch(params, '/ForVIPApply', true)
}

// 城市合伙人-开通
export function ForCFDMOpen(params) {
  return fetch(params, '/ForCFDMOpen', true)
}

// 申请零售云店铺开通
export function applyRCSOpen(params) {
  return fetch(params, '/applyRCSOpen', true)
}
// 惠康云店-兑换奖金
export function ForHKYDScoreExchangeMoney(params) {
  return fetch(params, '/ForHKYDScoreExchangeMoney', true)
}

// 惠康云店-兑换产品
export function ForHKYDScoreExchangeProduct(params) {
  return fetch(params, '/ForHKYDScoreExchangeProduct', true)
}

// 云端快递超市-开通云店铺接口
export function ForCESOpenCS(params) {
  return fetch(params, '/ForCESOpenCS', true)
}

// 产品服务站-开通惠康云店接口
export function ForPSSOpenHKYD(params) {
  return fetch(params, '/ForPSSOpenHKYD', true)
}

// 云店铺购物券明细列表
export function ForCESQLogList(params) {
  return fetch(params, '/ForCESQLogList', true)
}

// 专属产品(鬼谷回春堂/血德平)购物券明细列表
export function ForPSSQLogList(params) {
  return fetch(params, '/ForPSSQLogList', true)
}

// 开通权转让接口
export function ForKTQTurn(params) {
  return fetch(params, '/ForKTQTurn', true)
}

// 开通权明细接口
export function ForKTQLogList(params) {
  return fetch(params, '/ForKTQLogList', true)
}

// 开通权购买申请接口
export function ForKtqApply(params) {
  return fetch(params, '/ForKtqApply', true)
}

// 云店版块（云店铺）申请接口
export function ForStocomApply(params) {
  return fetch(params, '/ForStocomApply', true)
}

// 根据guid获取云店铺，单品代理的增选价格
export function getSinglePrice(params) {
  return fetch(params, '/getSinglePrice', true)
}

// 查询用户云店铺单个信息（资格）
export function getProxyFirstById(params) {
  return fetch(params, '/getProxyFirstById', true)
}

// 会员接口获取 流量分红数据 2021.11.14会员接口获取流量分红数据接口删除
// export function personalHBnum (params) {
//   return fetch(params, '/personalHBnum', true)
// }
// 意见反馈
export function feedback(params) {
  return fetch(params, '/feedback', true)
}

// 选货
export function addProxyProduct(params) {
  return fetch(params, '/addProxyProduct', true)
}

// 产品周转中心
export function ForPTCOpen(params) {
  return fetch(params, '/ForPTCOpen', true)
}

// 产品周转中心可申请列表
export function FindPTCLists(params) {
  return fetch(params, '/FindPTCLists', true)
}

// 惠康区域代理开通申请
export function ForHKQYAOpen(params) {
  return fetch(params, '/ForHKQYAOpen', true)
}

// 惠康区域代理-可申请列表
export function FindHKQYALists(params) {
  return fetch(params, '/FindHKQYALists', true)
}

// 版块代理-开通
export function ForBKAOpen(params) {
  return fetch(params, '/ForBKAOpen', true)
}

// 平台销售红包（平台代理）-开通
export function ForPTAOpen(params) {
  return fetch(params, '/ForPTAOpen', true)
}

// 平台区域代理-开通（改成了钻石云店铺）20210806取消该功能
// export function ForPAAOpen (params) {
//   return fetch(params, '/ForPAAOpen', true)
// }
// 查询用户云店铺信息（资格）
export function getProxyListById(params) {
  return fetch(params, '/getProxyListById', true)
}

// 申请赠送单品代理
export function applyGiftProxy(params) {
  return fetch(params, '/applyGiftProxy', true)
}

// 根据用户ID查询购买过的产品编码（申请单品代理中用）
export function findBuyProductByUid(params) {
  return fetch(params, '/findBuyProductByUid', true)
}

// 根据用户手机号查询单品赠送代理
export function findMsmCouponListByPhone(params) {
  return fetch(params, '/findMsmCouponListByPhone', true)
}

// 更换单品代理
export function addLMProduct(params) {
  return fetch(params, '/addLMProduct', true)
}

// 判断是否可更换代理产品
export function IsMSMChange(params) {
  return fetch(params, '/IsMSMChange', true)
}

// 云店铺代理产品更换接口
export function ForMSMGoodsChange(params) {
  return fetch(params, '/ForMSMGoodsChange', true)
}

// 云店铺产品列表接口
export function ForGetMSMGoodsList(params) {
  return fetch(params, '/ForGetMSMGoodsList')//true,表示进入页面需要登陆
}

// 批发云店铺产品-列表(去重后)
export function ForGetMSMGoodsMyList(params) {
  return fetch(params, '/ForGetMSMGoodsMyList')//true,表示进入页面需要登陆
}

// 批发云店铺产品-列表(全部)
export function ForGetMSMGoodsAllList(params) {
  return fetch(params, '/ForGetMSMGoodsAllList')//true,表示进入页面需要登陆
}

// 全国厂家总店产品列表
export function ForGetNFHGoodsAllList(params) {
  return fetch(params, '/ForGetNFHGoodsAllList')
}

// 全国厂家总店产品添加
export function ForNFHGoodsAdd(params) {
  return fetch(params, '/ForNFHGoodsAdd')
}

// 全国厂家总店产品更换
export function ForNFHGoodsChange(params) {
  return fetch(params, '/ForNFHGoodsChange')
}

// 全国厂家总店-可选货数量接口
export function ForNFHCanXHNum(params) {
  return fetch(params, '/ForNFHCanXHNum')
}

// 根据guid判断是否有大于50铜板的订单
export function IsMyorderpoint(params) {
  return fetch(params, '/IsMyorderpoint')//true,表示进入页面需要登陆
}

// 支付方式列表
export function payMethodList(params) {
  return fetch(params, '/payMethodList')
}

// ---------------------------- 订单 ------------------------

// 结算
export function buyCommodity(params) {
  return fetch(params, '/buyCommodity', true)
}

// 订单结算
export function addGroupOrder(params) {
  return fetch(params, '/addGroupOrder', true)
}

// 淘客订单列表
export function AmoyOrderList(params) {
  return fetch(params, '/AmoyOrderList', true)
}

// 拼团订单列表
export function groupOrderList(params) {
  return fetch(params, '/groupOrderList', true)
}

// 拼团提现
export function ptapplyWithdraw(params) {
  return fetch(params, '/ptapplyWithdraw', true)
}

// 我的拼团账单列表
export function myGroupBillList(params) {
  return fetch(params, '/myGroupBillList', true)
}

// 云店订单列表
export function cloudOrderList(params) {
  return fetch(params, '/cloudOrderList', true)
}

// 根据拼团id获取拼团订单
export function getGroupsAndOrder(params) {
  return fetch(params, '/getGroupsAndOrder', true)
}

// 商圈订单列表（20200901之前）
export function sqOrderList(params) {
  return fetch(params, '/sqOrderList', true)
}

// 根据会员ID查询下过的附近商圈的订单（已分账的订单）（20200901之后）
export function ForGetMyShoporder(params) {
  return fetch(params, '/ForGetMyShoporder', true)
}

// 原因列表(包含取消订单和申请退款原因)
export function reasonList(params) {
  return fetch(params, '/reasonList', true)
}

// 订单取消
export function cancelOrder(params) {
  return fetch(params, '/cancelOrder', true)
}

// 申请退款
export function refundOrder(params) {
  return fetch(params, '/refundOrder', true)
}

// 取消退款
export function cancelrefundOrder(params) {
  return fetch(params, '/cancelrefundOrder', true)
}

// 商圈订单详情
export function sqOrderDetail(params) {
  return fetch(params, '/sqOrderDetail', true)
}

// 云店订单详情
export function ydOrderDetail(params) {
  return fetch(params, '/ydOrderDetail', true)
}

// 团长申请
export function shenqing_group(params) {
  return fetch(params, '/shenqing_group', true)
}

// 获取团长信息
export function shenqingInfo(params) {
  return fetch(params, '/shenqingInfo', true)
}

//根据拼团id获取地址
export function getGroupsAddress(params) {
  return fetch(params, '/getGroupsAddress', true)
}

// 根据拼团id获取获取当前团的参团人信息
export function getgroupListinfo(params) {
  return fetch(params, '/getgroupListinfo', true)
}

// 评价
export function evaluateOrder(params) {
  return fetch(params, '/evaluateOrder', true)
}

// 确认收货
export function confirmShouhuo(params) {
  return fetch(params, '/confirmShouhuo', true)
}

// 获取运费
export function getFreight(params, isHidden) {
  return fetch(params, '/getFreight', true, isHidden)
}

// // 绑定淘宝
// export function bindTaobao (params) {
//   return fetch(params, '/bindTaobao', true)
// }
// 绑定淘宝
export function getRelationId(params) {
  return fetch(params, '/getRelationId', true)
}

// 生成淘口令
export function openTklCreate(params) {
  return fetch(params, '/openTklCreate', true)
}

// 物流查询
export function getExpressList(params) {
  return fetch(params, '/getExpressList', true)
}

// 物流查询
export function ForMSMApply(params) {
  return fetch(params, '/ForMSMApply', true)
}

// -------------------------支付----------------------
// 微信支付
export function wxPay(params) {
  return fetch(params, '/wxPay')
}

// 支付宝支付
export function h5Pay(params) {
  return fetch(params, '/h5Pay', true)
}

// 我惠支付
export function wohuiPay(params) {
  return fetch(params, '/wohuiPay')
}

// 客服
export function customerList(params) {
  return fetch(params, '/customerList', true)
}

/* 2023.09.22 之后的新方案*/

//获取配置信息
export function getConfigPrice(params) {
  return fetch(params, "/getConfigPrice", true)
}
//申请单品代理
export function ForApplyPCA(params) {
  return fetch(params, '/applyPCA', true)
}
// 申请开店云店铺-开通
export function ForApplyCFM(params) {
  return fetch(params, '/applyCFM', true)
}
//申请全国厂家总店
export function ForApplyNFH(params) {
  return fetch(params, '/applyNFH', true)
}


//申请借支
export function ForXBorrowApply(params) {
  return fetch(params, '/ForXBorrowApply', false)
}

//借支信息表
export function ForXBorrowList(params) {
  return fetch(params, '/ForXBorrowList', false)
}

export function ForTest(params) {
  return fetchX(params, '/Test3', true)
}



// WEBPACK FOOTER //
// ./src/api/my.js